module.exports = __webpack_public_path__ + "images/flyer1-3c95e8f5bcb71b653340685d67ddbc5d.jpg";